import React from 'react';
import { Button } from '../button';
import { ArrowLeftOutlined } from '@ant-design/icons';
import style from './style.module.scss';

export const PageTopBar = (props: {
    children?: React.ReactNode;
    title: React.ReactNode;
    /** Beside the title: a picker or a status tag for what the page shows. */
    titleExtra?: React.ReactNode;
    goBack?: {
        callback: () => void;
        text: string;
    };
}) => {
    return (
        <div className={style.page_top_bar}>
            <div className={style.page_top_bar_content}>
                {props.goBack && (
                    <Button
                        variant="secondary"
                        icon={<ArrowLeftOutlined />}
                        onClick={props.goBack.callback}
                    >
                        {props.goBack.text}
                    </Button>
                )}
                <h1 className={`${style.title} h5_bold`}>{props.title}</h1>
                {props.titleExtra}
            </div>
            <div className={style.title_actions}>{props.children}</div>
        </div>
    );
};
